export const loginHostUrl = process.env.REACT_APP_LOGIN_HOST_URL;
export const cookiesNameJwt = process.env.REACT_APP_COOKIES_NAME_JWT;
export const landchinaWsUrl =
  process.env.REACT_APP_LANDCHINA_WS_URL || "ws://localhost.avaval.com:4000";
export const landchinaMsgCrawling = "crawling";
export const landchinaMsgFindEstimatedTime = "findEstimatedTime";
export const landchinaMsgCancel = "cancel";
export const downloadHostUrl = process.env.REACT_APP_DOWNLOAD_HOST_URL;